<template>
  <div class="edit-product">
    <div class="breadcrumb" style="background: #fff">活动详情</div>
    <div class="third-title"><span>管理活动</span></div>
    <div class="order-detail-basic" style="padding-top: 0">
      <el-form ref="rules" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动类型"> {{ detail.activityType == 'FULL_AMOUNT' ? '满N元优惠' : '满N件优惠' }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动名称"> {{ detail.activityName }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动时间"> {{ detail.dateStart }} - {{ detail.dateEnd }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠详情">
              <div>
                <span v-for="item in detail.rules" :key="item.createdId" style="margin-left: 5px;">满{{ item.fullAmount }}{{ item.ladderDiscounts == 1 ? '元' : '件' }}{{ item.ladderDiscounts == 4 ? '每件'
                    : ''
                }}{{ item.ladderDiscounts == 2 ? '打' : '减' }}{{ item.discountAmount }}{{ item.ladderDiscounts == 2 ? '折' : '元' }}，</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="满减类型"> {{ detail.activityScope == 1 ? '各自满减' : '混合满减' }} </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="third-title"><span>选择产品</span></div>
    <div style="padding: 20px 30px;">
      <div style="width:100%;display: flex;justify-content:space-between;">
        <div>选择产品 已选数量{{ spuXrefs.length || 0 }}个</div>
        <el-input placeholder="请输入产品名称" v-model="spuName" class="input-with-select" style="width:300px;">
          <el-button slot="append" icon="el-icon-search" style="width:30px;" @click="spuNameSearch"></el-button>
        </el-input>
      </div>
      <el-table :data="spuXrefs" style="width: 100%;margin-top:20px;">
        <el-table-column prop="spuName" label="产品信息" width="300">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <img :src="scope.row.spuImage" alt="" width="50" height="50">
              <div style="padding-left: 10px;">{{ scope.row.spuName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="spuMinBasePrice" label="产品会员价">
          <template slot-scope="scope">
            <span v-show="scope.row.spuMinBasePrice == scope.row.spuMaxBasePrice">￥{{ scope.row.spuMinBasePrice }}</span>
            <span v-show="scope.row.spuMinBasePrice != scope.row.spuMaxBasePrice">￥{{ scope.row.spuMinBasePrice }} -￥{{ scope.row.spuMaxBasePrice }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="产品库存">
          <template>9999</template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>
<script>
import { getActivityById } from '@/api/pms'
export default {
  name: 'promo-detail',
  data () {
    return {
      spuXrefs: [],
      spuName: '',
      detail: {},
      number: 0
    }
  },
  created () {
    let id = this.$route.query.id
    if (id) {
      getActivityById(id).then(res => {
        if (res.data.data) {
          this.detail = res.data.data
          this.spuXrefs = JSON.parse(JSON.stringify(this.detail.spuXrefs))
        }
      })
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    spuNameSearch () {
      console.log('this.spuName', this.spuName)
      if (this.spuName) {
        this.spuXrefs = this.detail.spuXrefs.filter(a => {
          if (a.spuName.indexOf(this.spuName) !== -1) {
            return a
          }
        })
        console.log(' this.spuXrefs ', this.spuXrefs)
      } else {
        this.spuXrefs = this.detail.spuXrefs
      }
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

/deep/.el-checkbox-button__inner {
  display: inline-block;
  width: 90px;

}
</style>
